import { Injectable } from '@angular/core';

/** To samo co `PatientListStateService`, dla listy historii pracy w sekcji Raporty. */
@Injectable({ providedIn: 'root' })
export class WorkHistoryListStateService {
  filters: string[];
  sortColumn: string;
  sortDirection: 'asc' | 'desc';

  constructor() {
    this.clear();
  }

  clear(): void {
    this.filters = [];
    this.sortColumn = '';
    this.sortDirection = 'asc';
  }
}
